import { render, staticRenderFns } from "./InlineButtonIcon.vue?vue&type=template&id=c58b639e&scoped=true&"
import script from "./InlineButtonIcon.vue?vue&type=script&lang=js&"
export * from "./InlineButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./InlineButtonIcon.vue?vue&type=style&index=0&id=c58b639e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b639e",
  null
  
)

export default component.exports